import { callbackUrls } from "@ssf/auth-components";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.jsx";
import { App as TraditionalClubsApp } from "./traditional-clubs/App.jsx";
import { isTraditionalClubs } from "./traditional-clubs/lib/routes.js";

if (!Object.values(callbackUrls).includes(location.pathname)) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      {isTraditionalClubs() ? <TraditionalClubsApp /> : <App />}
    </StrictMode>,
  );
}
